// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c6E30{position:fixed;inset:0;z-index:200001;display:flex;align-items:center;justify-content:center;background:#fcfcfd;opacity:1;transition-property:opacity;transition-timing-function:ease-out}.c6E30.Hzg25{opacity:0}.OzYU1{width:60%;max-width:320px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `300`,
	"popover": `550`,
	"overlay": `c6E30`,
	"overlayStride": `4`,
	"portalledCalendar": `1500`,
	"dragOverlay": `100010`,
	"toast": `100020`,
	"globalLoader": `200000`,
	"nativeSplash": `200001`,
	"fading": `Hzg25`,
	"lottie": `OzYU1`
};
export default ___CSS_LOADER_EXPORT___;
